import { prefersReducedMotion } from '@/utils/reducedMotion';
import { animate, type AnimeParams } from 'animejs';

export default function startAnimation(target: HTMLElement | undefined, options: AnimeParams) {
  if (target === undefined) return;

  const default_options = {
    duration: 250,
    ease: 'outQuad'
  }

  options = {
    ...default_options,
    ...options
  }

  if (prefersReducedMotion()) {
    options.duration = 0
  }

  return animate(target, options);
}